module.exports = __webpack_public_path__ + "static/media/14UNEP6.e5dc683b.jpg";